import { request } from './client';
import {
  ClassRoomGroup,
  ClassRoomPublic,
  CreateClassRoomPayload,
  UpdateClassRoomPayload,
} from './types';

export function listClassrooms(): Promise<ClassRoomGroup[]> {
  return request<ClassRoomGroup[]>('/classrooms');
}

export function getClassroom(id: string): Promise<ClassRoomPublic> {
  return request<ClassRoomPublic>(`/classrooms/${id}`);
}

export function createClassroom(
  payload: CreateClassRoomPayload
): Promise<ClassRoomPublic> {
  return request<ClassRoomPublic>('/classrooms', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function updateClassroom(
  payload: UpdateClassRoomPayload
): Promise<ClassRoomPublic> {
  const { id, ...body } = payload;
  return request<ClassRoomPublic>(`/classrooms/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function deleteClassroom(payload: {
  id: string;
}): Promise<ClassRoomPublic> {
  return request<ClassRoomPublic>(`/classrooms/${payload.id}`, {
    method: 'DELETE',
  });
}
